'use client';

import { MaskedPhone } from '../../maskedPhone';

import IconMail from '@/assets/icons/iconMail.svg';
import IconPhoneWhite from '@/assets/icons/iconPhoneWhite.svg';
import { Link } from '@/shared/components/link';
import { TranslatedComponent } from '@/shared/types';

export const MaskedPhoneBlock = ({ translations }: TranslatedComponent) => {
  return (
    <div className="w-full max-w-[1168px] py-2">
      {/** Блок для мобильных */}
      <div className="flex w-full flex-col gap-9 md:hidden">
        <div className="flex flex-col gap-3">
          <p className="text-text-base-secondary flex-grow text-[14px] leading-[20px]">
            {translations.footerFooterMenuSectionsContactsTitle}
          </p>
          <MaskedPhone
            containerClassName="flex items-start max-w-[430px] flex-col gap-2 bg-(--surface-base-blur-secondary) rounded-[12px] py-3 px-4"
            phoneNumberClassName="text-[16px] leading-[24px] tracking-[-0.08px]"
            phoneNumberMaskClassName="text-[16px] leading-[24px] tracking-[-0.08px]"
            messageClassName="text-text-base-secondary text-[14px] leading-[20px]"
            iconDotsClassName="h-4 w-4"
            phoneNumber={
              translations.footerFooterMenuSectionsContactsItemsPhoneName
            }
            message={translations.formPhoneConsentMessage}
            loadingMessage={translations.loadingMessage}
            IconStart={
              <IconPhoneWhite className="me-3 flex h-6 w-6 shrink-0" />
            }
          />
        </div>
        <div className="flex flex-col gap-4">
          <Link variant="small" href="mailto:dev@2gis.ru">
            <IconMail className="mr-1 inline w-5" />
            <span className="text-[12px] leading-[16px] font-medium">
              {translations.footerFooterMenuSectionsContactsItemsEmailName}
            </span>
          </Link>
          <span className="text-text-base-secondary text-[14px] leading-[20px]">
            {translations.footerFooterMenuCopyright}
          </span>
        </div>
      </div>

      {/** Блок для ПК */}
      <div className="flex w-full justify-between max-md:hidden">
        <div className="row-span-2 flex justify-end gap-3">
          <div className="flex flex-col gap-3">
            <p className="text-text-base-secondary flex-grow">
              {translations.footerFooterMenuSectionsContactsTitle}
            </p>
            <MaskedPhone
              containerClassName="bg-(--surface-base-blur-secondary) rounded-[12px] flex flex-col  max-w-[430px] p-3 gap-2"
              phoneNumberClassName="text-[16px] leading-[32px] tracking-[-0.08px]"
              phoneNumberMaskClassName="text-[16px] leading-[32px] tracking-[-0.08px]"
              messageClassName="text-text-base-secondary text-[14px] leading-[20px]"
              iconDotsClassName="h-4 w-4"
              phoneNumber={
                translations.footerFooterMenuSectionsContactsItemsPhoneName
              }
              message={translations.formPhoneConsentMessage}
              loadingMessage={translations.loadingMessage}
              IconStart={
                <IconPhoneWhite className="me-3 flex h-6 w-6 shrink-0" />
              }
            />
          </div>
        </div>
        <div className="flex flex-col justify-between">
          <Link variant="small" href="mailto:dev@2gis.ru">
            <IconMail className="mr-1 inline w-6" />
            {translations.footerFooterMenuSectionsContactsItemsEmailName}
          </Link>
          <span className="text-text-base-secondary">
            {translations.footerFooterMenuCopyright}
          </span>
        </div>
      </div>
    </div>
  );
};
